import './components/share'

import './scss/st18/styles.scss'
